import { ApiError } from '@/lib/pillarApi';
import {
    CredentialDeleteConflictResponseSchema,
    type CredentialUsageListItem,
} from '@anchorbase/pillar-sdk';

export function parseCredentialDeleteConflictUsages(
    error: unknown
): CredentialUsageListItem[] | null {
    if (!(error instanceof ApiError)) {
        return null;
    }
    const parseResult = CredentialDeleteConflictResponseSchema.safeParse(error.body);
    if (!parseResult.success) {
        return null;
    }
    return parseResult.data.usages;
}
